import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'total_fac_area_m2_only_built_premises'

export const dataPointDefinition = {
  retracedId: 'total_fac_area_m2_only_built_premises',
  name: 'Total Facility Area (m2) - only built premises:',
  description: 'Does not include outdoor space.',
  meta: {
    unit: 'SQUARE_METRE',
  },
  fieldTypeId: 'NUMBER_UOM',
  type: 'RELATIONAL',
  options: [
    {
      key: 'SQUARE_METRE',
      name: 'Square Metre',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'number',
      },
      unit: {
        type: 'string',
        enum: ['SQUARE_METRE'],
        minLength: 1,
      },
    },
    required: ['value', 'unit'],
  },
  externalIds: [
    {
      id: 'fp-bs-10',
      version: '1.6.0',
      provider: 'slcp',
    },
  ],
  sortingId: 880,
  sectionId: '2.2.6.3',
  impactArea: 'Building and Operating Licenses',
  impactAreaId: 'BUILDING_AND_OPERATING_LICENSES',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
